import type { MailboxInfo } from 'owa-client-types';

/**
 * Identifies an explicit-logon resource MailboxInfo that is associated with a different
 * coprincipal. Applies across Mail and Calendar, not only linked shared calendars.
 */
export function isExplicitLogonResourceMailboxInfo(mailboxInfo: MailboxInfo): boolean {
    if (mailboxInfo.type !== 'UserMailbox' || !mailboxInfo.isExplicitLogon) {
        return false;
    }

    if (mailboxInfo.mailboxPrefixedIdentity || mailboxInfo.mailboxRank === 'Resource') {
        return true;
    }

    return (
        !!mailboxInfo.coprincipalMailboxSmtpAddress &&
        mailboxInfo.mailboxSmtpAddress.toLowerCase() !==
            mailboxInfo.coprincipalMailboxSmtpAddress.toLowerCase()
    );
}
